import styles from './index.module.sass';
import ArrowSvg from './arrow';
import { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';

export const SelectUniversal = ({ activeItem, onChange, options, placeholder }: IInputSelect) => {
  const [dropdownActive, setDropdownActive] = useState(false);
  const myRef = useRef<HTMLInputElement>(null);
  const offsetWidth = myRef.current?.offsetWidth;
  const offsetHeight = myRef.current?.offsetHeight;
  const coords = myRef.current?.getBoundingClientRect();

  useEffect(() => {
    function handleClickOutside(event: any) {
      if (myRef.current && !myRef.current.contains(event.target)) {
        setDropdownActive(false);
      }
    }

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <div
      ref={myRef}
      className={classNames(styles.inputSelect, dropdownActive && styles.inputActive)}
      onClick={() => setDropdownActive(!dropdownActive)}
    >
      <div className={styles.inputBody}>
        <span className={styles.label}>
          {activeItem && activeItem.label !== '' && activeItem ? `${activeItem.label}` : placeholder ? placeholder : 'не выбрано'}
        </span>
        <span className={styles.arrow}>
          <ArrowSvg active={dropdownActive} />
        </span>
      </div>
      {dropdownActive && (
        <div
          className={styles.dropdownBody}
        //   style={{
        //     top: Number(coords?.top) + Number(offsetHeight),
        //     left: coords?.left,
        //     width: offsetWidth,
        //   }}
        >
          <ul className={styles.dropdownList}>
            {options
              .map((option, i) => (
                <li
                  key={i}
                  className={classNames(
                    styles.dropdownListItem,
                    activeItem?.id === option.value && styles.activeItem,
                  )}
                  onClick={() => {
                    onChange(String(option.value));
                    setDropdownActive(false);
                  }}
                >
                  <span className={styles.itemLabel}>{option.label}</span>
                </li>
              ))}
          </ul>
        </div>
      )}
    </div>
  );
};

interface IInputSelect {
  placeholder?: string;
  activeItem?: { id: string; label: string } | any;
  onChange: (value: string) => void;
  options: {
    value: number | string;
    label: string | number;
  }[];
}